import { useState, useEffect } from 'react';
import { updateProfileDescription } from '../../../api/social';
import { useSocial } from '../../../context/socialProvider';
import { Save } from './Save';

interface GeneralSettingsProps {
  selectedSocial: any;
}

const GeneralSettings = ({ selectedSocial }: GeneralSettingsProps) => {
  const { currentSocial, refreshSocialInfo } = useSocial();

  // Profile Settings State
  const [initialProfileDescription, setInitialProfileDescription] =
    useState('');
  const [profileDescription, setProfileDescription] = useState('');
  const [isSavingProfileDescription, setIsSavingProfileDescription] =
    useState(false);

  // Test Simulation State
  const [modComment, setModComment] = useState('');

  // Initialize state from selectedSocial
  useEffect(() => {
    if (selectedSocial) {
      setProfileDescription(selectedSocial.profileDescription || '');
      setInitialProfileDescription(selectedSocial.profileDescription || '');
    }
  }, [selectedSocial]);

  // Profile Description Functions
  const handleProfileDescriptionSave = async () => {
    if (!selectedSocial) return;
    setIsSavingProfileDescription(true);
    try {
      await updateProfileDescription(selectedSocial.id, profileDescription);
      if (currentSocial?.id === selectedSocial.id) {
        await refreshSocialInfo();
      }
      setInitialProfileDescription(profileDescription);
    } catch (error) {
      console.error('Error saving profile description:', error);
    } finally {
      setIsSavingProfileDescription(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Profile Settings */}
      <div className="settings-container bio bg-grey rounded-xl p-6 shadow-lg border border-gray-700">
        <h2 className="font-semibold text-xl text-white mb-4">
          Profile Settings
        </h2>

        {/* Profile Name */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-200 mb-2">
            Profile Name
          </label>
          <input
            type="text"
            className="bg-black border border-gray-600 rounded p-3 w-full text-sm text-white focus:outline-none focus:ring-2 focus:ring-violet"
            placeholder="Enter profile name..."
            value={selectedSocial?.providerName || ''}
            readOnly
          />
          <p className="text-xs text-gray-400 mt-1">
            Profile name is read-only and set by the connected platform
          </p>
        </div>

        {/* Profile Summary */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-200 mb-2">
            Profile Summary
          </label>
          <textarea
            className="bg-black border border-gray-600 rounded p-3 w-full text-sm text-white focus:outline-none focus:ring-2 focus:ring-violet h-80"
            placeholder="Enter your profile summary here..."
            value={profileDescription}
            onChange={(e) => setProfileDescription(e.target.value)}
          />
          <p className="text-xs text-gray-400 mt-1">
            This summary helps the AI understand your brand and personality for
            better responses
          </p>
          <Save
            initialValue={initialProfileDescription}
            currentValue={profileDescription}
            isLoading={isSavingProfileDescription}
            onClick={handleProfileDescriptionSave}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
